module.exports = __webpack_public_path__ + "static/img/banner-perfil-home-768x1024.3c35cc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-perfil-home-768x1024.jpg
// module id = N3Qj
// module chunks = 47